import React from 'react';
import PageToolbar from 'Components/Page/Toolbar/PageToolbar';
import PageToolbarButton from 'Components/Page/Toolbar/PageToolbarButton';
import PageToolbarSection from 'Components/Page/Toolbar/PageToolbarSection';
import { align, icons } from 'Helpers/Props';
import AdvancedSettingsButton from './AdvancedSettingsButton';

interface SettingsToolbarProps {
  advancedSettings: boolean;
  onAdvancedSettingsPress: () => void;
  isSaving?: boolean;
  isSaveDisabled?: boolean;
  hasPendingChanges?: boolean;
  onSavePress?: () => void;
}

export default function SettingsToolbar({ advancedSettings, onAdvancedSettingsPress, isSaving, isSaveDisabled, hasPendingChanges = false, onSavePress }: SettingsToolbarProps) {
  return <PageToolbar>
    <PageToolbarSection alignContent={align.LEFT}>
      <AdvancedSettingsButton advancedSettings={advancedSettings} onPress={onAdvancedSettingsPress} />
      {onSavePress && <PageToolbarButton label={hasPendingChanges ? 'Save Changes' : 'No Changes'} iconName={icons.SAVE} isSpinning={isSaving} isDisabled={isSaveDisabled || !hasPendingChanges} onPress={onSavePress} />}
    </PageToolbarSection>
  </PageToolbar>;
}
